import React from "react";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

type Column = string | { name: string; isSortable?: boolean };

interface ListHeaderProps {
  columns: Column[];
  onColumnClick?: (columnKey: string) => void;
  sortDirection?: "asc" | "desc" | undefined;
  sortColumnName?: string;
}

const ListHeader = (props: ListHeaderProps) => {
  const { columns, onColumnClick, sortDirection, sortColumnName } = props;

  return (
    <TableHead>
      <TableRow>
        {columns.map((column: Column) => {
          const columnName = typeof column === "string" ? column : column.name;
          const isSortable =
            typeof column === "string" ? false : column.isSortable;
          return (
            <TableCell
              key={columnName}
              onClick={() => {
                if (onColumnClick && isSortable) {
                  onColumnClick(columnName);
                }
              }}
              sx={{
                cursor: isSortable ? "pointer" : "default",
                userSelect: isSortable ? "none" : "auto",
                "&:hover": isSortable ? { backgroundColor: "#e8e8e8" } : {},
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <span>{columnName}</span>
                {sortColumnName === columnName && sortDirection && (
                  <Box component="span" sx={{ display: "flex", ml: 0.5 }}>
                    {sortDirection === "asc" ? (
                      <ArrowDropUpIcon fontSize="small" />
                    ) : (
                      <ArrowDropDownIcon fontSize="small" />
                    )}
                  </Box>
                )}
              </Box>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

export default ListHeader;
